import { parseJSON } from 'date-fns/fp';
import { Timestamp } from '#components/atoms/timestamp/Timestamp.tsx';
import { useTime } from '#hooks/useTime.ts';
import { relativePastTime } from '#util/time.ts';

type Props = {
  className?: string;
  lastSeenAt: string | undefined | null;
};

export function LastSeenAt({ className, lastSeenAt }: Props) {
  const currentTime = useTime();
  if (!lastSeenAt) {
    return <span className={className}>Never</span>;
  }

  return (
    <Timestamp className={className} datetime={lastSeenAt}>
      {relativePastTime(parseJSON(lastSeenAt), currentTime)}
    </Timestamp>
  );
}
